import { AuthLayout, MainLayout } from "@/app";
import { Attendance, AttendanceList, AttendanceMeditationRetreatList } from "@/components/Attendance";
import { Contacts } from "@/components/Contacts";
import { Dashboard } from "@/components/Dashboard";
import { AlmsDonors, Donations, FoundingDonors, PadethaDonors } from "@/components/Donors";
import { ForgotPassword } from "@/components/ForgotPassword";
import { Login } from "@/components/Login";
import { MeditationRetreatList, MeditationRetreatsByYear } from "@/components/MeditationRetreats";
import { CancellationRequestRegistrants, Meditators, MeditatorsByRetreat, NewRegistrants, OldRegistrants, RegisteredMeditators } from "@/components/Meditators";
import { Posts } from "@/components/News";
import { RoomList, RoomDetail } from "@/components/Rooms";
import { AddAdminAccount, Payments, SendNotification, UserList } from "@/components/Settings";
import { NFCContainer } from "@/components/Settings/NFC";
import { NotFound } from "@/components/common";
import { MeditatorTabs } from "@/constants";
import { RouteObject } from "react-router";

export default [
    {
        Component: MainLayout,
        children: [
            {
                index: true,
                Component: Dashboard
            },
            {
                path: "/meditation-retreats",
                Component: MeditationRetreatsByYear
            },
            {
                path: "/news",
                Component: Posts,
            },
            {
                path: "/contacts",
                Component: Contacts
            },
            {
                path: "/meditators",
                children: [
                    {
                        index: true,
                        Component: Meditators
                    },
                ]
            },
            {
                path: "/meditator-list-by-retreat",
                children: [
                    {
                        index: true,
                        Component: MeditationRetreatList
                    },
                    {
                        path: `:retreatId`,
                        Component: MeditatorsByRetreat
                    }
                ]
            },
            {
                path: "/retreat-registrants",
                children: [
                    {
                        index: true,
                        Component: RegisteredMeditators,
                    },
                    {
                        path: `:retreatId/${MeditatorTabs.new_registrants}`,
                        Component: NewRegistrants
                    },
                    {
                        path: `:retreatId/${MeditatorTabs.old_registrants}`,
                        Component: OldRegistrants
                    },
                ]
            },
            {
                path: "/cancelled-registrants",
                children: [
                    {
                        index: true,
                        Component: CancellationRequestRegistrants,
                    },
                ]
            },
            {
                path: "/donations",
                Component: Donations
            },
            {
                path: "/alms-donors",
                Component: AlmsDonors
            },
            {
                path: "/fund-donors",
                Component: FoundingDonors
            },
            {
                path: "/padetha-donors",
                Component: PadethaDonors
            },
            {
                path: "/send-notification",
                Component: SendNotification
            },
            {
                path: "/new-account",
                Component: AddAdminAccount
            },
            {
                path: "/payment-methods",
                Component: Payments
            },
            {
                path: "/users",
                Component: UserList
            },
            {
                path: "/nfc",
                Component: NFCContainer
            },
            {
                path: "/attendance",
                children: [
                    {
                        index: true,
                        Component: Attendance
                    },
                    {
                        path: "meditation-retreats",
                        Component: AttendanceMeditationRetreatList
                    },
                    {
                        path: "meditation-retreats/:id/detail",
                        Component: AttendanceList
                    }
                ]
            },
            {
                path: "/rooms",
                children: [
                    {
                        index: true,
                        Component: RoomList
                    },
                    {
                        path: ":id/detail",
                        Component: RoomDetail
                    }
                ]
            },
        ]
    },
    {
        Component: AuthLayout,
        children: [
            {
                path: "/login",
                Component: Login
            },
            {
                path: "/forgot-password",
                Component: ForgotPassword
            }
        ]
    },
    {
        path: "*",
        Component: NotFound
    }
] satisfies RouteObject[]